import {Game} from "./game";

export class Result {
  matchId: number;
  games: Game[] = [];
}
